export class ReportingConstants {
  // Tab values
  public static readonly ActivityDashboardTab = {
    id: 'tab-activity-dashboard',
    name: 'Activity Dashboard',
  };
  public static readonly BenchmarkDashboardTab = {
    id: 'tab-benchmark-dashboard',
    name: 'Benchmark Dashboard',
  };
  public static readonly CreateReportsTab = {
    id: 'tab-create-reports',
    name: 'Create Reports',
  };
  public static readonly ViewReportsTab = {
    id: 'tab-view-reports',
    name: 'View Reports',
  };

  // MeasureOn values
  public static readonly Assets: string = 'Assets';
  public static readonly NetSales: string = 'Net Sales';
  public static readonly NetFlows: string = 'Net Flows';
  public static readonly Positions: string = 'Positions';
  public static readonly Purchases: string = 'Purchases';
  public static readonly Redemptions: string = 'Redemptions';

  // MeasureBy values
  public static readonly ByChannel: string = 'By Channel';
  public static readonly ByMorningstarAssetClass: string =
    'By Morningstar Asset Class';
  public static readonly ByMorningstarCategory: string =
    'By Morningstar Category';
  public static readonly ByProductType: string = 'By Product Type';
  public static readonly ByShareClass: string = 'By Share Class';
  public static readonly ByAssetType: string = 'By Asset Type';

  // Benchmark Rescale Y Axis constants
  public static readonly RescaleLinear: string = 'Linear';
  public static readonly RescaleLogarithmic: string = 'Logarithamic';

  // Chart Colors - Providence color palette
  public static readonly CHART_COLORS: string[] = [
    '#013B61',
    '#1DADE2',
    '#568200',
    '#FFCD00',
    '#CC4700',
    '#9D66C1',
    '#6792AF',
    '#001D30',
    '#757A02',
    '#DBE068',
    '#FB9914',
    '#7C33AC',
    '#78CEEE',
    '#0C465B',
    '#BBCD99',
    '#446800',
    '#662300',
    '#BD99D5',
  ];

  // Template errors & warnings
  public static readonly MAX_NUM_TEMPLATES = 25;
  public static readonly MAX_TEMPLATE_NAME_LENGTH = 50;
  public static readonly TEMPLATE_NAME_ERROR_TITLE =
    'Enter a valid template name';
  public static readonly NUM_TEMPLATES_WARNING =
    `You already have the maximum of ${this.MAX_NUM_TEMPLATES} templates for this report type. ` +
    'You may continue without saving this template. ' +
    'Use the "Manage Templates" feature to delete one or more templates in order to save a new template.';
  public static readonly NUM_TEMPLATES_ERROR =
    `You have already generated the maximum number of ${this.MAX_NUM_TEMPLATES} templates for this report type. ` +
    'You may still run this report without saving.';
  public static readonly TEMPLATE_NAME_ERROR =
    'Template name cannot be blank or have special characters.';
  public static readonly TEMPLATE_NAME_SPECIAL_CHARS_ERROR =
    'Template name cannot have special characters.';
  public static readonly TEMPLATE_NAME_DUPLICATE_ERROR =
    'Template name already exists. Please enter a new name.';
  public static readonly TEMPLATE_NAME_LENGTH_ERROR = `Template name cannot exceed ${this.MAX_TEMPLATE_NAME_LENGTH} characters.`;

  // Other Constants
  public static readonly EMPTY_STRING: string = '';
  public static readonly DEFAULT_TEMPLATE_VALUE: string =
    'System Default Template';
  public static readonly VIEW_REPORTS_ERROR_MESSAGE: string =
    'An unexpected application error has occurred. Please contact your Systems Administrator.';
  public static readonly FUNDSNETWORK_LOGIN_URL: string = 'login.aspx';
}
